import { CONTACT } from "@/data";
import { Phone, Mail, Clock, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="bg-cream text-ink pt-20 pb-10 border-t border-ink/10">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center">
            <img src="/logo.png" alt="Garage Cleaners" width="440" height="161" loading="lazy" decoding="async" className="h-16 w-auto" />
          </div>
          <p className="mt-5 text-ink/60 max-w-sm leading-relaxed">
            Cleanouts, deep cleans, smart storage and same-day upgrades — one crew, one day, a garage you'll want to use.
          </p>
          <Link to="/estimate" className="mt-6 inline-flex bg-ink text-paper px-6 py-3 font-semibold hover:bg-rust transition-colors">
            Get a Free Estimate
          </Link>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-ink/50">Contact</h4>
          <ul className="mt-5 space-y-3 text-ink/80">
            <li className="flex items-center gap-3"><Phone size={16} className="text-rust" /><a href={CONTACT.phoneHref} className="hover:text-rust transition-colors">{CONTACT.phone}</a></li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-rust" /><a href={`mailto:${CONTACT.email}`} className="hover:text-rust transition-colors">{CONTACT.email}</a></li>
            <li className="flex items-center gap-3"><Clock size={16} className="text-rust" />{CONTACT.hours}</li>
            <li className="flex items-center gap-3"><MapPin size={16} className="text-rust" />{CONTACT.region}</li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-ink/50">Explore</h4>
          <ul className="mt-5 space-y-3 text-ink/80">
            <li><a href="/#benefits" className="hover:text-rust transition-colors">The Difference</a></li>
            <li><a href="/#process" className="hover:text-rust transition-colors">Process</a></li>
            <li><a href="/#gallery" className="hover:text-rust transition-colors">Results</a></li>
            <li><a href="/#dream" className="hover:text-rust transition-colors">AI Preview</a></li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-ink/10 flex flex-col sm:flex-row justify-between gap-4 text-sm text-ink/40">
        <p>© {new Date().getFullYear()} Garage Cleaners. All rights reserved.</p>
        <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-ink/70 transition-colors">Team Login</Link>
      </div>
    </div>
  </footer>
);
